import { Ref, computed, ComputedRef } from "vue";
import { IFetchSummary, useCreditLineSummary } from "./useCreditLineSummary";
import { PayJoyCardStatus } from "@/apps/credit-line/models/PayJoyCardStatus";

interface RolloutSelectors {
  isVirtualCardEnabled: ComputedRef<boolean>;
  isReportingTransactionsEnabled: ComputedRef<boolean>;
  isLoading: Ref<boolean>;
  fetchSummary: IFetchSummary;
}

// ToDo: Delete this hook in favor of configurability
export function useSummaryRolloutSelectors(): RolloutSelectors {
  const { summary, isLoading, fetchSummary } = useCreditLineSummary();

  const isReportingTransactionsEnabled = computed(() => {
    if (!summary.value) {
      return false;
    }

    return summary.value?.isReportingTransactionsEnabled ?? false;
  });

  const isVirtualCardEnabled = computed(() => {
    if (!summary.value) {
      return false;
    }

    return (
      (summary.value.isVirtualCardEnabled &&
        summary.value.creditCardStatus !== PayJoyCardStatus.NONE) ||
      false
    );
  });

  return {
    isVirtualCardEnabled,
    isReportingTransactionsEnabled,
    isLoading,
    fetchSummary,
  };
}
